export default __webpack_public_path__ + "static/article-tips-to-help-you-become-a-super-saver-ee4e2bc4dcbb3a14f6aa9e81601f1088.webp";